/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import * as embedAPIUtil from 'utils/api/embed';
import * as labelsAPIUtil from 'utils/api/labels';
import { batchActions } from 'redux-batched-actions';
import { selectEmbedUUID } from 'state/actions/embedsState/embedAnalytics';



/* ========== ~~~~~~~~~~ EMBEDS STATUS : ACTIONS ~~~~~~~~~~ ========== */
import { failedApiCallReroute } from 'utils/messages';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { setSelectedEmailEmbed } from 'state/actions/emailCollectionState/selected_embed_email_status';
// import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { receiveEmbedData } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { receiveContentData, receiveSortedContentData, fetchingSortedEmbedAnalytics } from 'state/actions/embedsState/embedManagementState/content_status';
import { updatePageDetails, changePage, displayModal, displayErrorMessage, displaySuccessMessage } from '@insticator/insticator-ui'; // iui-state




/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const FETCHING_CLIENT_EMBEDS_DATA = 'FETCHING_CLIENT_EMBEDS_DATA';
export const RECEIVE_CLIENT_EMBEDS_DATA = 'RECEIVE_CLIENT_EMBEDS_DATA';
export const REMOVE_EMBED_DATA = 'REMOVE_EMBED_DATA';
export const RECEIVE_LABELS = 'RECEIVE_LABELS';
export const ADD_LABEL = 'ADD_LABEL';
export const DELETE_LABEL = 'DELETE_LABEL';
export const SET_EMBED_CARD_LABELS = 'SET_EMBED_CARD_LABELS';
export const ARCHIVING = 'ARCHIVING';
export const TOGGLE_ARCHIVE = 'TOGGLE_ARCHIVE';
export const FETCHING_EMBED_NAMES = 'FETCHING_EMBED_NAMES';
export const RECEIVE_EMBED_NAMES = 'RECEIVE_EMBED_NAMES';

//actions

const fetchingClientEmbedsData = status => ({
    type: FETCHING_CLIENT_EMBEDS_DATA,
    status
});

const receiveClientEmbedsData = data => ({
    type: RECEIVE_CLIENT_EMBEDS_DATA,
    data
});

export const removeEmbedData = embedUUID => ({
    type: REMOVE_EMBED_DATA,
    embedUUID
});

const archivingStatus = embedUUID => ({
    type: ARCHIVING,
    embedUUID
});

const toggleArchive = embedUUID => ({
    type: TOGGLE_ARCHIVE,
    embedUUID
});

export const setEmbedCardLabels = (embedUUID, labelUUIDs) => ({
    type: SET_EMBED_CARD_LABELS,
    embedUUID,
    labelUUIDs
});

const fetchingEmbedNames = status => ({
    type: FETCHING_EMBED_NAMES,
    status
});

const receiveEmbedNames = names => ({
    type: RECEIVE_EMBED_NAMES,
    names
});

const getEmbedNamesSuccess = names => batchActions([receiveEmbedNames(names), fetchingEmbedNames(false)]);
const getEmbedNamesFail = names => batchActions([displayErrorMessage('We are facing issues with embed creation.'), fetchingEmbedNames(false)]);


//batchedActions

const getClientEmbedsDataSuccess = data => batchActions([receiveClientEmbedsData(data), fetchingClientEmbedsData(false)]);
const getClientEmbedsDataFail = err => batchActions([displayErrorMessage('There was an issue fetching your embeds'), fetchingClientEmbedsData(false)]);

const archiveEmbedSuccess = (embedUUID, embedName) => batchActions([displaySuccessMessage(`${embedName} embed is now archived`), toggleArchive(embedUUID), archivingStatus(null)]);
const archiveEmbedFail = () => batchActions([displayErrorMessage('There was an issue archiving this embed'), archivingStatus(null)]);

const unarchiveEmbedSuccess = (embedUUID, embedName) => batchActions([displaySuccessMessage(`${embedName} embed is now live`), toggleArchive(embedUUID), archivingStatus(null)]);
const unarchiveEmbedFail = () => batchActions([displayErrorMessage('There was an issue making this embed live'), archivingStatus(null)]);


export const getClientEmbedsData = (accountUUID, filters) =>  dispatch => {
    dispatch(fetchingClientEmbedsData(true));
    embedAPIUtil.getClientEmbedsData(accountUUID, filters)
        .then(response => dispatch(getClientEmbedsDataSuccess(response.data)))
        .catch(err => dispatch(getClientEmbedsDataFail()))
        // .catch(err => failedApiCallReroute(err.response.status))
};
const receiveLabels = labels => ({
    type: RECEIVE_LABELS,
    labels
});

const addLabel = label => ({
    type: ADD_LABEL,
    label
});

const deleteLabelFromState = labelUUID => ({
    type: DELETE_LABEL,
    labelUUID
});

export const getLabels = accountUUID => dispatch => (
    labelsAPIUtil.acyncRequestLabels(accountUUID)
        .then(response => dispatch(receiveLabels(response.data)))
        .catch(() => dispatch(displayErrorMessage('There was an issue fetching your labels')))
);

export const createLabel = (accountUUID, labelName, callback=null) => dispatch => (
    labelsAPIUtil.asyncCreateLabel(accountUUID, labelName)
        .then(response => {
            dispatch(addLabel({[response.data]: labelName}));
            if(!!callback && typeof callback === 'function') callback(response.data)
        })
        .then(() => dispatch(displaySuccessMessage('We have successfully created your label')))
        .catch(() => dispatch(displayErrorMessage('There was an issue creating your labels')))
);

export const updateLabel = (labelUUID, labelName, callback=null) => dispatch => (
    labelsAPIUtil.asyncUpdateLabel(labelUUID, labelName)
        .then(() => dispatch(addLabel({ [labelUUID]: labelName })))
        .then(() => dispatch(displaySuccessMessage('We have successfully saved your label')))
        .then(response => { if(!!callback && typeof callback === 'function') callback(response) })
        .catch(() => dispatch(displayErrorMessage('There was an issue creating your labels')))
);

export const deleteLabel = (labelUUID, callback=null) => dispatch => (
    labelsAPIUtil.asyncDeleteLabel(labelUUID)
        .then(response => dispatch(deleteLabelFromState(labelUUID)))
        .then(() => dispatch(displaySuccessMessage('We have successfully deleted your label')))
        .then(response => { if(!!callback && typeof callback === 'function') callback(response.data.failedLabelUUIDs) })
        .then(() => dispatch(displayModal(false)))
        .catch(() => dispatch(displayErrorMessage('There was an issue deleting the label')))
);

export const attachLabelToEmbed = (accountUUID, embedUUID, labelUUIDs, callback=null) => dispatch => (
    labelsAPIUtil.asyncAttachLabelsToEmbed(accountUUID, embedUUID, labelUUIDs)
        .then(response => {
            dispatch(setEmbedCardLabels(embedUUID, response.data.attachedLabelUUIDs));
            if(!!callback && typeof callback === 'function') callback(response.data.createdLabels)
        })
        .catch(() => dispatch(displayErrorMessage('There was an issue creating your labels')))
);

// receive all of the embed data (including all of the contents) and navigate the user to edit a selected embed
export const editEmbed = embedUUID => dispatch => (
    embedAPIUtil.getEmbedByUUID(embedUUID)
        .then(response => dispatch(batchActions([
            receiveEmbedData({ ...response.data.embed, ...response.data.site }),
            receiveContentData(response.data.contents),
        ])))
        .then(() => dispatch(updatePageDetails('dashboard/embeds/management/customize')))
        .then(() => dispatch(updateStepDetails('customize')))
        .then(() => dispatch(changePage('dashboard/embeds/management/customize')))
        .catch(err => dispatch(failedApiCallReroute(err.response.status)))
);

export const viewAnalytics = (embedUUID, accountUUID, embedName) => dispatch => dispatch(analyticsBatchedActions(embedUUID, embedName));


export const viewEmails = (embedUUID, embedName) => dispatch => {
        dispatch(setSelectedEmailEmbed(embedUUID, embedName));
        dispatch(updatePageDetails('dashboard/embeds/management/embedcontent'));
        dispatch(updateStepDetails('customize'));
        dispatch(changePage('dashboard/embeds/emails'));
};

const deleteEmbedFail = (callback) => dispatch => {
    if (!!callback && typeof callback === 'function') callback();
    return dispatch(
        batchActions([
            displayModal(false),
            displayErrorMessage('There was an issue deleting your embed')]
        ));
};

export const deleteEmbed = (embedUUID, accountUUID, callback) => dispatch => (
    embedAPIUtil.deleteEmbedByUUID(embedUUID)
        .then(() => dispatch(removeEmbedData(embedUUID)))
        .then(() => dispatch(displayModal(false)))
        .then(() => dispatch(displaySuccessMessage('We have successfully deleted your embed')))
        .then(() => callback())
        .catch(() => dispatch(deleteEmbedFail(callback)))
);

const analyticsBatchedActions = (embedUUID, embedName) => dispatch => {
      dispatch(selectEmbedUUID(embedUUID, embedName));
      dispatch(updatePageDetails('dashboard/embeds/management/embedcontent'));
      dispatch(updateStepDetails('customize'));
      dispatch(changePage('dashboard/embeds/analytics/embedcontent'));
};

export const moveToLibrary = accountUUID => dispatch => {
    dispatch(updatePageDetails('library'));
    dispatch(changePage('dashboard/embeds'))
};

export const archiveEmbed = (embedUUID, embedName, callBack) => dispatch => {
    dispatch(archivingStatus(embedUUID));
    embedAPIUtil.archiveEmbed(embedUUID)
        .then(response => {
            !!callBack && callBack();
            return dispatch(archiveEmbedSuccess(embedUUID, embedName))
        })
        .catch(err => dispatch(archiveEmbedFail()))
};

export const unarchiveEmbed = (embedUUID, embedName, callBack) => dispatch => {
    dispatch(archivingStatus(embedUUID));
    embedAPIUtil.unarchiveEmbed(embedUUID)
        .then(response => {
            !!callBack && callBack();
            return dispatch(unarchiveEmbedSuccess(embedUUID, embedName))
        })
        .catch(err => dispatch(unarchiveEmbedFail()))
};

export const getEmbedNames = (accountUUID, cb) => dispatch => {
    dispatch(fetchingEmbedNames(true));
  embedAPIUtil.asyncGetEmbedNames(accountUUID)
      .then(response => {
          dispatch(getEmbedNamesSuccess(response.data));
          cb && cb();
      })
      .catch(err => dispatch(getEmbedNamesFail()))
};
